module.exports = __webpack_public_path__ + "static/advantage_product1-4d76d2b403e64bd701c140afd38460fb.jpg";